import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import get from "lodash/get";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";

const fields = [
  {
    name: "Name",
    key: "accessories.name",
    isRequired: true,
  },
  {
    name: "Type",
    key: "type",
    isRequired: true,
    renderField: (value) => getOptionLabel("accessoryType", value),
  },
  {
    name: "Load Type",
    key: "loadType",
    isRequired: true,
    renderField: (value) => getOptionLabel("powerRequirementOptions", value),
  },
  {
    name: "Quantity",
    key: "quantity",
    isRequired: true,
  },
  {
    name: "Borne By Company",
    key: "isBorneByCompany",
    isRequired: true,
    renderField: (value) => (value ? "Yes" : "No"),
  },
  {
    name: "Amount",
    key: "amount",
    isRequired: true,
    renderField: (value) => <p>&#x20B9; {value}</p>,
  },
];

const AccessoriesListView = ({ accessories, isExpandable = true, t }) => {
  return (
    <Collapse
      title="Technical Sanction Estimation Details"
      isExpandable={isExpandable}
    >
      {accessories.map((accessory, index) => (
        <Fragment key={accessory.id}>
          <h5>{t("Item") + ` ${index + 1}`}</h5>
          <Row className="d-flex  mb-2">
            {fields.map(({ name, key, isRequired, renderField }) => {
              const value = get(accessory, key, "");

              return (
                <Col key={key} lg={6} className="mb-1">
                  <Row>
                    <Col md={5}>{t(name)}:</Col>
                    <Col
                      md={7}
                      className="fw-semibold"
                      style={{ wordBreak: "break-word" }}
                    >
                      {renderField
                        ? renderField(value)
                        : get(accessory, key, null) ??
                          (isRequired ? "-" : "N/A")}
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </Row>
        </Fragment>
      ))}
    </Collapse>
  );
};

AccessoriesListView.propTypes = {
  accessories: PropTypes.array,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(AccessoriesListView);
